export default "__VITE_ASSET__CzJaLx1R__"